export default __webpack_public_path__ + "static/media/photo_5282747746622312904_y.336334d2.jpg";